export default "__VITE_ASSET__DnkV5GvH__"